var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "searchBox" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: { inline: false, "label-position": "top" },
          model: {
            value: _vm.queryForm,
            callback: function ($$v) {
              _vm.queryForm = $$v
            },
            expression: "queryForm",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { size: "small" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selectClass",
                              style: _vm.IsWidth,
                              attrs: {
                                placeholder: _vm.$t(
                                  "orderDetails.pleaseChoose"
                                ),
                                size: "small",
                              },
                              on: { change: _vm.handleChangeLable },
                              model: {
                                value: _vm.queryForm.params.searchNumberType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "searchNumberType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.searchNumberType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.anjunWaybillNumber"
                                  ),
                                  value: "1",
                                },
                              }),
                              _c("el-option", {
                                key: "8",
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.ScanNumber"),
                                  value: "8",
                                },
                              }),
                              _c("el-option", {
                                key: "5",
                                attrs: {
                                  label: _vm.$t(
                                    "GlobalSetObj.serviceLogistics"
                                  ),
                                  value: "5",
                                },
                              }),
                              _c("el-option", {
                                key: "15",
                                attrs: {
                                  label: _vm.$t(
                                    "GlobalSetObj.anJunOrderNumber"
                                  ),
                                  value: "15",
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("newOrder.PlatformOrderNumber"),
                                  value: "2",
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.PickUpBagNumber"
                                  ),
                                  value: "3",
                                },
                              }),
                              _c("el-option", {
                                key: "4",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.TransitBinBagNumber"
                                  ),
                                  value: "4",
                                },
                              }),
                              _c("el-option", {
                                key: "7",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.SubpackageNumber"
                                  ),
                                  value: "7",
                                },
                              }),
                              _c("el-option", {
                                key: "17",
                                attrs: {
                                  label: _vm.$t("driver.cteInvoiceNumber"),
                                  value: "17",
                                },
                              }),
                              _c("el-option", {
                                key: "10",
                                attrs: {
                                  label:
                                    "NFE" + _vm.$t("newOrder.InvoiceNumber"),
                                  value: "10",
                                },
                              }),
                              _c("el-option", {
                                key: "9",
                                attrs: {
                                  label: "NFE" + _vm.$t("newOrder.InvoiceKey"),
                                  value: "9",
                                },
                              }),
                              _c("el-option", {
                                key: "16",
                                attrs: {
                                  label: _vm.$t("driver.recipientCPF"),
                                  value: "16",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticStyle: { "margin-top": "3px" },
                        attrs: {
                          placeholder: _vm.$t("newOrder.PreciseSearch1"),
                          rows: 2,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.searchNumberStr,
                          callback: function ($$v) {
                            _vm.searchNumberStr = $$v
                          },
                          expression: "searchNumberStr",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "searchTimeType", size: "small" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selectClass",
                              style: _vm.IsWidthTime,
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.SwitchTimeType },
                              model: {
                                value: _vm.queryForm.params.searchTimeType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "searchTimeType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.searchTimeType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("newOrder.createTime"),
                                  value: "1",
                                },
                              }),
                              _c("el-option", {
                                key: "5",
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.customerDeliveryTime"
                                  ),
                                  value: "5",
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t("newOrder.TransitInboundTime"),
                                  value: "3",
                                },
                              }),
                              _c("el-option", {
                                key: "4",
                                attrs: {
                                  label: _vm.$t("newOrder.shipmentTime"),
                                  value: "4",
                                },
                              }),
                              _c("el-option", {
                                key: "7",
                                attrs: {
                                  label: _vm.$t("orderCenterCont.deliveryTime"),
                                  value: "7",
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("orderCenterCont.SigningTime"),
                                  value: "2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%", "margin-top": "3px" },
                        attrs: {
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("operationCenter.endDate"),
                          format:
                            _vm.$i18n.locale === "zh" ? _vm.zhDate : _vm.ptDate,
                          "picker-options": _vm.pickerOptions,
                          "start-placeholder": _vm.$t(
                            "operationCenter.startDate"
                          ),
                          "range-separator": "~",
                          size: "small",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: {
                          change: _vm.handleTime,
                          input: function ($event) {
                            return _vm.changeInput($event)
                          },
                        },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("newOrder.waybillStatus") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.all"),
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                            size: "small",
                          },
                          on: { change: _vm.selectStatus },
                          model: {
                            value: _vm.queryForm.params.waybillStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "waybillStatus",
                                $$v
                              )
                            },
                            expression: "queryForm.params.waybillStatus",
                          },
                        },
                        _vm._l(_vm.waybillStatusList, function (item, ind) {
                          return _c("el-option", {
                            key: ind,
                            attrs: { label: item.label, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("newOrder.CustomerName"),
                        name: "customerIds",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.OnlyAreDisplayed"
                            ),
                            "remote-method": _vm.getCustomerPage,
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            remote: "",
                            "reserve-keyword": "",
                            size: "small",
                          },
                          on: {
                            clear: function ($event) {
                              return _vm.getCustomerPage("")
                            },
                            focus: _vm.getCustomerPageFuc,
                          },
                          model: {
                            value: _vm.queryForm.params.customerIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerIds", $$v)
                            },
                            expression: "queryForm.params.customerIds",
                          },
                        },
                        _vm._l(_vm.customerList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label:
                                item.customerAlias + "(" + item.username + ")",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "28px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { size: "small", type: "info" },
                        on: { click: _vm.resetForm },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("customerManagements.reset")) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "SearchExpansion",
                        on: {
                          click: function ($event) {
                            _vm.show3 = !_vm.show3
                          },
                        },
                      },
                      [
                        _vm.show3
                          ? _c("i", {
                              staticClass: "iconfont icon-a-ziyuan410",
                            })
                          : _c("i", {
                              staticClass: "iconfont icon-a-ziyuan310",
                            }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show3,
                  expression: "show3",
                },
              ],
              attrs: { gutter: 10 },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("placeOrder.cargoType"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.queryForm.params.cargoType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "cargoType", $$v)
                            },
                            expression: "queryForm.params.cargoType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: "",
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("placeOrder.normal01"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.big01"),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("placeOrder.packageType"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.queryForm.params.orderPackageType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "orderPackageType",
                                $$v
                              )
                            },
                            expression: "queryForm.params.orderPackageType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("placeOrder.zhifa"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("orderCenterCont.hedan"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "mdfeTranslate.multipleItemsPerOrder"
                              ),
                              value: 5,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.big01"),
                              value: 4,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("orderCenterCont.other"),
                              value: 3,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.tipoTitle"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryForm.params.isReverse,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "isReverse", $$v)
                            },
                            expression: "queryForm.params.isReverse",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.tudo"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.originalOrder"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.originalOrderReturned"
                              ),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.newOrderReturned"
                              ),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "trajectory.originalOrderReturn_D2D"
                              ),
                              value: 3,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.merchantCode"),
                        size: "small",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("orderDetails.pleaseInput"),
                          clearable: "",
                          size: "small",
                        },
                        model: {
                          value: _vm.queryForm.params.merchantCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm.params,
                              "merchantCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.params.merchantCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.MerchantName"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.OnlyAreDisplayed"
                            ),
                            "remote-method": _vm.getMerchantList,
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          model: {
                            value: _vm.queryForm.params.merchantCodeList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "merchantCodeList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.merchantCodeList",
                          },
                        },
                        _vm._l(_vm.merchantList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                item.merchantName + " - " + item.merchantCode,
                              value: item.merchantCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("newOrder.ActualCollection"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            "remote-method": _vm.remoteGetSiteList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.remoteGetSiteList("")
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.collectStationId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "collectStationId",
                                $$v
                              )
                            },
                            expression: "queryForm.params.collectStationId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show3,
                  expression: "show3",
                },
              ],
              attrs: { gutter: 10 },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selectClass",
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                size: "small",
                              },
                              model: {
                                value:
                                  _vm.queryForm.params
                                    .deliverWarehouseStationType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "deliverWarehouseStationType",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.deliverWarehouseStationType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.entrega"),
                                  value: "1",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.infeatSite"),
                                  value: "2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            "remote-method": _vm.remoteGetSiteList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            size: "small",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.remoteGetSiteList("")
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.deliverStationId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "deliverStationId",
                                $$v
                              )
                            },
                            expression: "queryForm.params.deliverStationId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.preEntrega"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            "remote-method": _vm.remoteGetSiteList,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.remoteGetSiteList("")
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.preDeliverStationId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "preDeliverStationId",
                                $$v
                              )
                            },
                            expression: "queryForm.params.preDeliverStationId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderCenterCont.deliveryPerson"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.OnlyAreDisplayed"
                            ),
                            "remote-method": _vm.getallDriver,
                            clearable: "",
                            filterable: "",
                            remote: "",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.getallDriver("")
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.deliveryManName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "deliveryManName",
                                $$v
                              )
                            },
                            expression: "queryForm.params.deliveryManName",
                          },
                        },
                        _vm._l(_vm.drvierList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.username,
                              value: item.username,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("receivablePayable.RecipientzipCode"),
                        size: "small",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("orderDetails.pleaseInput"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.params.receiveZipcode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm.params,
                              "receiveZipcode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.params.receiveZipcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("receivablePayable.receiveName"),
                        size: "small",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("orderDetails.pleaseInput"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryForm.params.receiveName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm.params,
                              "receiveName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "queryForm.params.receiveName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("newOrder.RecipientState"),
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.receiveStateList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "receiveStateList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.receiveStateList",
                          },
                        },
                        _vm._l(_vm.StateList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.label, value: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }